import { default as baseSlugify } from 'slugify'

export default function slugify(str: string | undefined): string {
  return baseSlugify(str?.replaceAll('/', ' ') ?? '', {
    lower: true,
  })
}
